import lang from "@/views/modules/Invitees/language/en";

let searchFieldsDef = {
    'assigned_user_id': {
        label: lang.LBL_PI_NAME,
        type:'selectcomponent',
        route: 'users',
        moduleName: 'Users',
        name: 'invitee_user_name',
        id: 'invitee_assigned_user',
    },
    'mobile': {
        label: lang.LBL_PI_MOBILE,
    },
    'professional': {
        label: lang.LBL_PI_PROFESSIONAL,
    },
    'description': {
        label: lang.LBL_DESCRIPTION,
    },
};
export default { searchFieldsDef }